<template>
  <div
    v-show="item.show"
    :class="['drag', action ? 'drag-action' : '']"
    :style="{
      zIndex: item.zIndex,
      transform: `translate3d(${x}px, ${y}px, 0)`,
      width: item.width + 'px',
      height: item.height + 'px'
    }"
    @touchstart="onStart"
    @touchmove.stop.prevent="onMove"
    @touchend="onEnd"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    safe: Object
  },
  data() {
    return {
      action: false,
      x: 0,
      y: 0
    };
  },
  created() {
    /**
     * 这里this.item也要监听
     * 因为下拉刷新时this.item一个全新的对象了
     */
    this.$watch(
      () => [this.item, this.item.left, this.item.top],
      () => {
        this.x = this.item.left;
        this.y = this.item.top;
      },
      { immediate: true }
    );
  },
  methods: {
    neverMoved() {
      const { x, y } = this;
      const { show, left, top } = this.item;
      return show && left === x && top === y;
    },
    onStart(e) {
      if (this.item.fixed) return;
      this.$emit('on-touchstart');
      const touch = e.changedTouches[0];
      this.startX = touch.clientX;
      this.startY = touch.clientY;
      this.prevX = this.x;
      this.prevY = this.y;
    },
    onMove(e) {
      if (this.item.fixed) return;
      const touch = e.changedTouches[0];
      const x = this.prevX + (touch.clientX - this.startX);
      const y = this.prevY + (touch.clientY - this.startY);
      const i = this.item;
      const s = this.safe;
      const m = s.margin;
      const w = s.width - m;
      const h = s.height - m;
      this.x = x <= m ? m : x + i.width >= w ? w - i.width : x;
      this.y = y <= m ? m : y + i.height >= h ? h - i.height : y;
    },
    onEnd(e) {
      if (this.item.fixed || !this.item.dragAdsorptive) return;
      const touch = e.changedTouches[0];
      const x = touch.clientX - this.startX;
      const y = touch.clientY - this.startY;
      if (x === 0 && y === 0) return;
      const i = this.item;
      const s = this.safe;
      const m = s.margin;
      const rtl = x < 0; // 是否是从右往左拖
      const half = s.width / 2; // 屏幕宽度一半
      const max = rtl ? half - i.width : half;
      this.x = this.x >= max ? s.width - i.width - m : m;
      this.action = true;
      setTimeout(() => {
        this.action = false;
      }, 300);
    }
  }
};
</script>

<style lang="less" scoped>
.drag {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
}
.drag-action {
  transition: transform 0.3s;
}
</style>
